export function StepFooter({ children }: { children: React.ReactNode }) {
  return (
    <div className="mt-3 flex items-center justify-between border-t border-border pt-3">
      {children}
    </div>
  );
}
